<template>
    <div class="fight-report-trainer-mini">
        <v-progress-circular v-if="!trainer" indeterminate color="primary" class="mt-4" />
        <template v-else>
            <div class="fight-report-trainer-mini__avatar-wrap">
                <v-img
                    v-if="trainer.img"
                    class="fight-report-trainer-mini__avatar"
                    :src="require(`@/assets/pic/trainer/${trainer.img}`)"
                    contain
                />
                <v-avatar size="34" class="fight-report-trainer-mini__level">
                    <v-icon class="fight-report-trainer-mini__level-star">mdi-star</v-icon>
                    <span class="fight-report-trainer-mini__level-text">{{ trainer.experience.level }}</span>
                </v-avatar>
            </div>
            <div class="fight-report-trainer-mini__skills">
                <v-tooltip v-for="(skill, key) in trainerSkillsConfig" :key="key" top>
                    <template v-slot:activator="{ on, attrs }">
                        <div class="fight-report-trainer-mini__skill-cell" v-bind="attrs" v-on="on">
                            <v-icon size="26" class="fight-report-trainer-mini__skill-icon">{{ skill.icon }}</v-icon>
                            <span class="fight-report-trainer-mini__skill-value">{{ trainer.trainerSkills[key] }}</span>
                        </div>
                    </template>
                    <span>{{ $t('trainer.trainerSkills.' + key + '.name') }}</span>
                </v-tooltip>
            </div>
        </template>
    </div>
</template>

<script>
import {TRAINER_SKILLS} from "@/utils/trainerSkillsEnum";

// Kompaktni horizontalni layout (avatar vlevo, 4x2 mrizka vpravo) - nazev
// skillu je v tooltipu, na radek vedle avataru uz se nevejde.
export default {
    name: "FightReportTrainerMini",
    props: {
        trainer: {type: Object, default: null},
    },
    data() {
        return {
            trainerSkillsConfig: TRAINER_SKILLS,
        };
    },
}
</script>

<style scoped>
.fight-report-trainer-mini {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: 6px 10px;
}
.fight-report-trainer-mini__avatar-wrap {
    position: relative;
    flex: 0 0 auto;
}
.fight-report-trainer-mini__avatar {
    width: 110px;
    height: 110px;
}
/* Stejny recept jako .pokemon-detail-level v PokemonDetail.vue. */
.fight-report-trainer-mini__level {
    position: absolute;
    right: -10px;
    bottom: -8px;
    box-shadow: 1px 3px 8px rgba(0, 0, 0, .5);
    background: radial-gradient(circle at 30% 30%, #ffffff, #494949);
}
.fight-report-trainer-mini__level-star.v-icon {
    z-index: 0;
    color: #ffebbc;
    position: absolute;
    font-size: 36px !important;
}
.fight-report-trainer-mini__level-text {
    position: relative;
    z-index: 1;
    font-size: 14px;
    font-weight: 900;
    color: #000;
}
.fight-report-trainer-mini__skills {
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 10px 28px;
}
.fight-report-trainer-mini__skill-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}
.fight-report-trainer-mini__skill-value {
    font-size: 22px;
    font-weight: 700;
    min-width: 22px;
}
</style>
